import formatRoutes from '@/helpers/user-redesign/formatRoutes';
// import { ROLES } from '@/constants/roles';
// import { DRAWER_TYPES } from '@/constants/drawer';

const routes = [
  // {
  //   path: '/redesign/events-search',
  //   name: 'events-search',
  //   component: () => import('@/modules/UserEvents/views/events-search.vue'),
  //   meta: {
  //     title: 'Поиск мероприятий',
  //   },
  // },
];

const withoutNavigationRoutes = [
  {
    path: '/redesign/events-search',
    name: 'events-search',
    component: () => import('@/modules/UserEvents/views/events-search.vue'),
    meta: {
      title: 'Поиск мероприятий',
      fluidContainer: true,
    },
  },
  {
    path: '/redesign/home',
    name: 'redesign-home',
    component: () => import('@/modules/UserEvents/views/certificate-home.vue'),
    meta: {
      title: 'Мои мероприятия',
    },
  },
  {
    path: '/redesign',
    name: 'redesign-main',
    component: () => import('@/modules/UserEvents/views/main.vue'),
    meta: {
      title: 'Главная',
      fluidContainer: true,
    },
  },
];

export default [
  ...formatRoutes(routes),
  ...formatRoutes(withoutNavigationRoutes, false, false),
];
